import i18n from "../../lang/i18n";
// Layouts
import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";

//University Pages
import CriterionList from "@/pages/University/Criterion/Index.vue";
import CriterionCreateForm from "@/pages/University/Criterion/CreateForm.vue";
import CriterionEditForm from "@/pages/University/Criterion/EditForm.vue";
import CriterionCategoryList from "@/pages/University/CriterionCategory/Index.vue";
import CriterionCategoryCreateForm from "@/pages/University/CriterionCategory/CreateForm.vue";
import CriterionCategoryEditForm from "@/pages/University/CriterionCategory/EditForm.vue";
import UniversityTemplateList from "@/pages/University/UniversityTemplate/Index.vue";
import UniversityTemplateCriteria from "@/pages/University/UniversityTemplate/UniversityTemplateCriteria.vue";
import UniversityList from "@/pages/University/Index.vue";
import UniversityCreateForm from "@/pages/University/CreateUniversityPage.vue";
import UniversityEditForm from "@/pages/University/EditUniversityPage.vue";
import ManageUniversityRatings from "@/pages/University/ManageUniversityRatings.vue";
import UniversityTypeList from "@/pages/University/UniversityType/Index.vue";
import UniversityTypeCreateForm from "@/pages/University/UniversityType/CreateForm.vue";
import UniversityTypeEditForm from "@/pages/University/UniversityType/EditForm.vue";
import UniversityDivisionList from "@/pages/University/UniversityDivision/Index.vue";
import UniversityDivisionCreateForm from "@/pages/University/UniversityDivision/CreateForm.vue";
import UniversityDivisionEditForm from "@/pages/University/UniversityDivision/EditForm.vue";
import ExportPdf from "@/pages/University/ExportPdf/Index.vue";
import ExportCertificateCover from "@/pages/University/ExportCertificateCover/Index.vue";

export const criterionPages = {
  path: "/criterion",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "CriterionList",
      components: { default: CriterionList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.criterion_list")
      }
    },
    {
      path: "add",
      name: "CriterionCreateForm",
      components: { default: CriterionCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.criterion_create")
      }
    },
    {
      path: ":id/view",
      name: "CriterionEditForm",
      components: { default: CriterionEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.criterion_edit")
      }
    }
  ]
};

export const criterionCategoryPages = {
  path: "/criterion-category",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "CriterionCategoryList",
      components: { default: CriterionCategoryList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.criterion_category_list")
      }
    },
    {
      path: "add",
      name: "CriterionCategoryCreateForm",
      components: { default: CriterionCategoryCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.criterion_category_create")
      }
    },
    {
      path: ":id/view",
      name: "CriterionCategoryEditForm",
      components: { default: CriterionCategoryEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.criterion_category_edit")
      }
    }
  ]
};

export const universityTemplatePages = {
  path: "/university-template",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "UniversityTemplateList",
      components: { default: UniversityTemplateList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_template_list")
      }
    },
    {
      path: ":id/management-criteria",
      name: "UniversityTemplateCriteria",
      components: { default: UniversityTemplateCriteria },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.management_template_criteria")
      }
    }
  ]
};

export const universityPages = {
  path: "/university",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "UniversityList",
      components: { default: UniversityList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_list")
      }
    },
    {
      path: "add",
      name: "UniversityCreateForm",
      components: { default: UniversityCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_create")
      }
    },
    {
      path: ":id/view",
      name: "UniversityEditForm",
      components: { default: UniversityEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_edit")
      }
    },
    {
      path: ":id/ratings",
      name: "ManageUniversityRatings",
      components: { default: ManageUniversityRatings },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.manage_university_score")
      }
    },
    {
      path: ":id/export-certificate",
      name: "ExportPdf",
      components: { default: ExportPdf },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.export_certificate")
      }
    },
    {
      path: ":id/export-certificate-cover",
      name: "ExportCertificateCover",
      components: { default: ExportCertificateCover },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.export_certificate_cover")
      }
    }
  ]
};

export const universityTypePages = {
  path: "/university-type",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "UniversityTypeList",
      components: { default: UniversityTypeList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_type_list")
      }
    },
    {
      path: "add",
      name: "UniversityTypeCreateForm",
      components: { default: UniversityTypeCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_type_create")
      }
    },
    {
      path: ":id/view",
      name: "UniversityTypeEditForm",
      components: { default: UniversityTypeEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_type_edit")
      }
    }
  ]
};

export const universityDivisionPages = {
  path: "/university-division",
  component: DashboardLayout,
  children: [
    {
      path: "",
      name: "UniversityDivisionList",
      components: { default: UniversityDivisionList },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_division_list")
      }
    },
    {
      path: "add",
      name: "UniversityDivisionCreateForm",
      components: { default: UniversityDivisionCreateForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_division_create")
      }
    },
    {
      path: ":id/view",
      name: "UniversityDivisionEditForm",
      components: { default: UniversityDivisionEditForm },
      meta: {
        requireAuth: true,
        title: i18n.t("page_title.university_division_edit")
      }
    }
  ]
};

export default {
  universityPages,
  universityTemplatePages,
  criterionPages,
  criterionCategoryPages,
  universityDivisionPages,
  universityTypePages
};
